var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"vk-btn-component",class:[{'vk-btn_plain':_vm.plain , 'vk-btn_disabled':_vm.disabled}, _vm.sizeClass],on:{"click":_vm.vkBtnClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }